angular.module("digitalLeasing.module").component("additionalAircraftInfo", {
    templateUrl: "ng/components/digitalLeasing/financialLeasingRequest/additionalAircraftInfo/additionalAircraftInfo.view.html",
    bindings: {
        model: "=",
        flyIsOk: "&",
        flyIsNotOk: "&",
        initialTabIndex: "="
    },
    controllerAs: "additionalAircraftInfoCtrl",
    controller: AdditionalAircraftInfolController
});

function AdditionalAircraftInfolController($typeDomainService) {
    var self = this;

    self.supportModel = {
        dropdown: {
            aircraftType: []
        },
        initialIndex: 0
    }

    self.$onInit = function () {
        self.supportModel.initialIndex = self.initialTabIndex || 0;
        getAircraftType();
        checkValidation();
    };

    var getAircraftType = function () {
        $typeDomainService.getDomainSet("ADDITIONAL_AIRCRAFT_INFO", "VEHICLE_TYPE").then(function (response) {
            self.supportModel.dropdown.aircraftType = response.domainList;
        });
    };

    self.handleChange = function (property, value) {
        switch (property) {
            case "tipo":
                self.model.tipo = value.name;
                break;
            default:
                self.model[property] = value;
                break;
        }

        checkValidation();
    }

    var checkValidation = function () {
        var test = false;
        test = self.model.tipo && self.model.marca &&
            self.model.modello && self.model.description &&
            self.model.aeroporto

        if (test) {
            self.flyIsOk();
        } else {
            self.flyIsNotOk();
        }
    }

}